import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";
import { useCart } from "@/context/CartContext";

/** One-tap Reorder (7.10): copy the lines into a new order and open Stripe with them. `cart` mode prefills the cart instead. */
export function useReorder() {
    const [busy, setBusy] = useState(false);
    const navigate = useNavigate();
    const { addItem } = useCart();

    const reorder = async ({ id, token, mode = "pay" }) => {
        setBusy(true);
        try {
            const body = { origin_url: window.location.origin, token: token || undefined, mode };
            const { data } = await api.post(token && !id ? `/orders/reorder/${token}` : `/orders/${id}/reorder`, body);
            if (mode === "cart") {
                data.items.forEach((it) => addItem(it));
                navigate("/cart");
                return;
            }
            if (data.checkout_url) {
                sessionStorage.setItem("pending_pay", JSON.stringify({ slug: null, order_id: data.order.id }));
                window.location.href = data.checkout_url;
                return;
            }
            navigate(`/order-confirmation/${data.order.id}`);
        } catch (e) {
            toast.error(formatApiError(e.response?.data?.detail) || "Couldn't reorder. Try again.");
            setBusy(false);
            return false;
        }
        return true;
    };
    return { reorder, busy };
}
